import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgReddit = function SvgReddit(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF4500",
        d: "M59.863 0h.274C93.177 0 120 26.823 120 59.863v.274C120 93.177 93.177 120 60.137 120h-.274C26.823 120 0 93.177 0 60.137v-.274C0 26.823 26.823 0 59.863 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M97.176 58.497c-.997-4.52-5.125-7.45-9.22-6.546-1.396.307-2.598 1.026-3.549 2.01-5.511-4.003-13.037-6.647-21.44-7.147l4.023-16.75 11.935 2.855a6.226 6.226 0 0 0 6.214 5.848c3.313 0 6.23-2.792 6.23-6.23 0-3.44-2.791-6.231-6.23-6.231a6.22 6.22 0 0 0-5.634 3.586l-12.948-3.099a1.9 1.9 0 0 0-2.288 1.4L59.817 46.73c-9.375.05-17.834 2.762-23.905 7.105a7 7 0 0 0-.967-.761c-3.535-2.258-8.42-.925-10.91 2.972-2.488 3.897-1.643 8.892 1.892 11.15q.316.2.643.361c-.142.87-.218 1.757-.218 2.653 0 12.97 15.097 23.485 33.722 23.485 18.624 0 33.721-10.515 33.721-23.485 0-.908-.08-1.804-.227-2.682 2.872-1.67 4.436-5.306 3.616-9.03zM42.782 64.77a5.352 5.352 0 1 1 10.704 0 5.352 5.352 0 0 1-10.704 0m29.724 16.896c-1.644 1.493-6.185 4.974-12.832 5.037h-.18c-6.736 0-11.335-3.515-13.013-5.037a1.31 1.31 0 0 1-.088-1.854 1.31 1.31 0 0 1 1.854-.088c1.46 1.328 5.491 4.41 11.402 4.355 5.747-.054 9.67-3.06 11.09-4.35a1.31 1.31 0 0 1 1.855.088 1.31 1.31 0 0 1-.088 1.854zm-.648-11.544a5.352 5.352 0 1 1 0-10.705 5.352 5.352 0 0 1 0 10.705"
    })));
};

export { SvgReddit as ReactComponent };
//# sourceMappingURL=Reddit.svg.es.js.map
